// extracted by mini-css-extract-plugin
export default {"cta":"IT58jffUoAeXUGaHEJah","container":"KTp08R9wf9boqt9Zs0Lw","logo":"QEuqO0uKmlOzNQCfcKKP"};